var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#FFD93B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9992 22.5C44.9992 34.9313 34.9234 45 22.4992 45C15.4258 45 9.11172 41.7375 4.98438 36.6258C8.84453 39.7477 13.7594 41.6109 19.1102 41.6109C31.5344 41.6109 41.6101 31.5422 41.6101 19.1109C41.6101 13.7602 39.7469 8.84531 36.625 4.98515C41.7297 9.1125 44.9992 15.4266 44.9992 22.5Z",
    fill: "#F4C534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5696 30.2695C32.5696 30.946 32.0226 31.493 31.3461 31.493H13.6541C12.9847 31.493 12.4307 30.946 12.4307 30.2695C12.4307 29.5931 12.9847 29.0461 13.6541 29.0461H31.3461C32.024 29.0475 32.5696 29.5931 32.5696 30.2695Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3388 21.5536C17.1904 21.5536 18.6913 20.0526 18.6913 18.2011C18.6913 16.3496 17.1904 14.8486 15.3388 14.8486C13.4873 14.8486 11.9863 16.3496 11.9863 18.2011C11.9863 20.0526 13.4873 21.5536 15.3388 21.5536Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2155 16.4916C16.9252 16.1015 16.4853 15.9375 16.233 16.1253C15.9806 16.3131 16.0114 16.7815 16.3016 17.1716C16.5919 17.5616 17.0317 17.7256 17.2841 17.5378C17.5364 17.3501 17.5057 16.8816 17.2155 16.4916Z",
    fill: "#5A5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6582 21.5536C31.5097 21.5536 33.0107 20.0526 33.0107 18.2011C33.0107 16.3496 31.5097 14.8486 29.6582 14.8486C27.8066 14.8486 26.3057 16.3496 26.3057 18.2011C26.3057 20.0526 27.8066 21.5536 29.6582 21.5536Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5337 16.4951C31.2435 16.1051 30.8036 15.9412 30.5513 16.129C30.299 16.3167 30.3297 16.7851 30.62 17.1752C30.9102 17.5652 31.3501 17.7291 31.6024 17.5413C31.8547 17.3536 31.824 16.8852 31.5337 16.4951Z",
    fill: "#5A5F63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfused);
export default __webpack_public_path__ + "static/media/confused.b652270e95d710b66fb0e9d083556bd9.svg";
export { ForwardRef as ReactComponent };